import React, {useState, useEffect, useCallback} from 'react';

import * as Constant from '@app/Constant.js';
import axios from '@app/lib/axios';

const BranchSelectBox = ({className, style, branch_id, branchList, callback}) => {
	// const [branchList, setBranchList] = useState(null);
	useEffect(() => {
        return () => {};
    }, [className, callback]);

	if(!branchList) return null;

	return (
		<select 
			className={className || 'form-control'}
			style={style}
			onChange={(e) => {
				const value= e.target.value;
				const result = {
					id: 0,
					name: '전체'
				}
				const filterData = branchList.filter((b) => {
					return b.id == value;
				});

				if(filterData && filterData.length === 1) {
					result.id = filterData[0].id;
					result.name = filterData[0].name;
				}

				if(callback) callback(result);
			}}
			value={branch_id}
		>
			<option key={`branch-all`} value="0">전체</option>
			{branchList.map((b) => {
				return (
					<option key={`branch-${b.id}`} value={b.id}>
						{b.name}
					</option>
				)
			})}
		</select>
	)
}


export default BranchSelectBox;
